/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Notifiche.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/Modules/Notifiche.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 24/04/25;
 * Updated at: 19/04/25;
 */

import { OggettoConfig } from "src/app/shared/_services/dynamic-crud.service";
import { CampoAggiuntivo } from "src/app/shared/models/campo-aggiuntivo";

function Notifiche() { 
    return {
        type: '*',
        addButton: true,
        hideif: { hasNotCapacity: ['gestione-news'] },
        restRoute: '/task/notifiche',
        Label: 'Notifica',
        Azioni: [
            { nome: 'Invia Notifiche', class: ' btn ', labelClass: 'ml-1 text-orange font-weight-bold', type: 'POST', restRoute: '/task/notifiche/send', capacita: [], icon: 'fas fa-plane text-orange', placeholder: 'Invia Notifiche ai Clienti', successMex: "Notifiche inviate", hideif: { fieldnotexist: 'id' }, parameter: [{ nome: "ids", parameter: 'clienti' }, { nome: 'news', parameter: 'id' }] },
            { nome: 'Elimina', close: true, class: ' btn ', labelClass: 'ml-1 text-danger font-weight-bold', type: 'POST', restRoute: '/task/nenotifiche/delete', preAlert: 'Sei sicuro di voler eliminare questo elemento?', capacita: ['gestione-news'], icon: 'fas fa-trash text-danger', hideif: { fieldnotexist: 'id' }, placeholder: 'Elimina', successMex: 'Elemento eliminato con successo', parameter: [{ nome: "id", parameter: 'id' }] },
        ],
        campi: [
            { nome: 'Titolo:', oggetti: ['nome'], modificabile: true, inputType: 'text', class: 'col-lg-12' },
            { nome: 'Body:', oggetti: ['note'], inputType: 'html', modificabile: true, class: 'col-lg-12' },
            { nome: 'Data:', oggetti: ['data_inizio_prevista'], modificabile: true, inputType: 'date', class: 'col-lg-3' },
            { nome: 'Data Fine:', oggetti: ['data_fine_prevista'], modificabile: true, inputType: 'date', class: 'col-lg-3' },
            { nome: 'Publica:', oggetti: ['publicata'], modificabile: true, inputType: 'checkbox', class: 'col-lg-3' },
            {
                type: 'image',
                oggetti: ['id_immagine'],
                imageToServer: 'immagine',
                filename: 'file',
                titleClass: 'control-label col-form-label',
                class: 'col-md-12',
                visibleifProhibited: true,
                modificabile: true
            },
            CampoAggiuntivo.SingleDropdown("Clienti", "addclienti", '/anagrafica/clienti/list', 'nominativo', { OnChange: "AddCli", parameter:[{nome: 'page', value:0}, {nome:'size', value: 10}, {nome:"ruolo", value: 'C'}], responseHasData:true }),
            { nome: 'Clienti Aggiunti', collapsable: true, collapsed: true, oggetti: ['clientiObject'], type: "table", header: [{ nome: "Cliente", oggetti: ['nominativo'] }], modificabile: true, class: 'col-lg-12', azioni: [{ ExternalOnClick: 'OnDelete', icon: 'fa-trash', tooltip: 'Elimina', color: 'red' }] },

        ]
    };
    
}


export var NotificheEnv = () => {

    var env = {
        TaskAddon: {
            checkList: false,
            DynamicFields: [Notifiche()]
        },
        filtrife: [
            { id: "*", label: "Notifiche", capacita: [], module: undefined, tipo: '*' },
        ],
        Menu: [
            {
                module: "Task",
                path: "/task/list/*/0/Vertical",
                title: 'Notifiche',
                icon: "fas fa-newspaper",
                capacita: ["menu-news"]
            }
        ]
    };
    
    return env;
}


